import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { 
  Box, 
  Heading, 
  Text, 
  Button, 
  Flex,
  useColorModeValue
} from '@chakra-ui/react';

function NotFound() {
  const headingColor = useColorModeValue('brand.500', 'brand.300');
  
  return (
    <Flex
      minHeight="70vh"
      align="center"
      justify="center"
      direction="column"
    >
      <Heading
        display="inline-block"
        as="h1"
        size="4xl"
        color={headingColor}
        mb={6}
      >
        404
      </Heading>
      <Text fontSize="xl" fontWeight="bold" mb={4}>
        Page Not Found
      </Text>
      <Text color={'gray.500'} mb={8} textAlign="center">
        The page you're looking for does not seem to exist
      </Text>

      <Button
        as={RouterLink}
        to="/"
        colorScheme="brand"
        size="lg"
      >
        Go to Dashboard
      </Button>
    </Flex>
  );
}

export default NotFound;
